<template>
    <div class="table-controls-wrapper">
        <el-input
            v-model="searchLanguages"
            :placeholder="$trans('profile_dossier.search_placeholder')"
            clearable
            style="width: 40%"
        >
            <template #suffix>
                <img
                    class="search-icon"
                    src="/media/images/search_gray.png"
                    alt="Search"
                />
            </template>
        </el-input>

        <EditButton
            class="ml-2 edit-button-vue"
            :onClick="redirectToLanguagesEdit"
        />
    </div>

    <EasyDataTable
        :headers="languagesHeadersComputed"
        :items="sortedLanguages"
        :search-value="searchLanguages"
        table-class-name="languages-table"
        :rows-per-page="languageItems.length"
        :buttons-pagination="false"
    >
        <template #item-action="{ id, is_selected }">
            <el-checkbox
                :key="`checkbox-${id}`"
                :checked="is_selected"
                @change="$emit('toggle', id)"
                :disabled="readOnly"
            />
        </template>

        <template v-slot:[languageHeaderSlotName]>
            <div
                @click="changeSort(languageNameKey)"
                :class="{ active: sortBy === languageNameKey }"
                style="
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    width: 100%;
                    height: 100%;
                    padding: 0 8px;
                    cursor: pointer;
                "
            >
                {{ $trans("profile_dossier.language_name") }}
                <SortIcons
                    :columnKey="languageNameKey"
                    :sortBy="sortBy"
                    :sortDesc="sortDesc"
                    style="vertical-align: middle; position: relative; top: 8px"
                />
            </div>
        </template>

        <template #header-level_name>
            <div
                @click="changeSort('level_name')"
                :class="{ active: sortBy === 'level_name' }"
                style="
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    width: 100%;
                    height: 100%;
                    padding: 0 8px;
                    cursor: pointer;
                "
            >
                {{ $trans("profile_dossier.language_level") }}
                <SortIcons
                    :columnKey="'level_name'"
                    :sortBy="sortBy"
                    :sortDesc="sortDesc"
                    style="vertical-align: middle; position: relative; top: 8px"
                />
            </div>
        </template>
    </EasyDataTable>
</template>

<script>
import EasyDataTable from "vue3-easy-data-table";
import SortIcons from "./SortIcons.vue";
import EditButton from "./../../../WebProfile/Components/EditButton.vue";
export default {
    name: "LanguagesTable",
    components: { 
        EasyDataTable, 
        SortIcons,
        EditButton
    },
    props: {
        languageItems: {
            type: Array,
            required: true,
        },
        appLocale: {
            type: String,
            default: "en",
        },
        readOnly: { type: Boolean, default: false },
        profileId: { type: [Number, String], required: true },
    },
    emits: ["toggle"],
    data() {
        return {
            searchLanguages: "",
            sortBy: "name",
            sortDesc: false,
        };
    },
    computed: {
        languagesHeadersComputed() {
            return [
                {
                    text: this.$trans("profile_dossier.action"),
                    value: "action",
                    width: 25,
                },
                {
                    text: this.$trans("profile_dossier.language_name"),
                    value: this.languageNameKey,
                    sortable: false,
                },
                {
                    text: this.$trans("profile_dossier.language_level"),
                    value: "level_name",
                    sortable: false,
                },
            ];
        },
        languageNameKey() {
            return this.appLocale === "de" ? "name_de" : "name";
        },
        languageHeaderSlotName() {
            return `header-${this.languageNameKey}`;
        },
        sortedLanguages() {
            if (!this.sortBy) return this.languageItems;
            return [...this.languageItems].sort((a, b) => {
                let valA = a[this.sortBy];
                let valB = b[this.sortBy];

                if (typeof valA === "string") valA = valA.toLowerCase();
                if (typeof valB === "string") valB = valB.toLowerCase();

                if (valA < valB) return this.sortDesc ? 1 : -1;
                if (valA > valB) return this.sortDesc ? -1 : 1;
                return 0;
            });
        },
    },
    methods: {
        changeSort(column) {
            if (this.sortBy === column) {
                this.sortDesc = !this.sortDesc;
            } else {
                this.sortBy = column;
                this.sortDesc = false;
            }
        },
        redirectToLanguagesEdit() {
            window.open(`/candidates/${this.profileId}/language`, '_blank');
        },
    },
};
</script>

<style scoped>
:deep(.vue3-easy-data-table__main) {
    margin-bottom: unset !important;
}

:deep(.vue3-easy-data-table__main tr td) {
    height: 1px !important;
}

:deep(.vue3-easy-data-table__main tr th),
:deep(.vue3-easy-data-table__main tr td) {
    border: 2px solid #ededed !important;
}

:deep(.vue3-easy-data-table__main tr td) {
    background: #ffffff !important;
    padding: 0.5rem !important;
    line-height: 20px !important;
}

:deep(.vue3-easy-data-table__main tr th) {
    border-top: 0;
    border-bottom: 0;
    background: rgb(237, 237, 237);
    padding: 0 0.5rem;
    color: #3c3c3c;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    height: 24px;
    line-height: 24px;
    font-family: sans-serif;
    border-top: unset;
}

:deep(.vue3-easy-data-table) {
    border: none !important;
}

:deep(.vue3-easy-data-table__footer) {
    background-color: transparent !important;
}

:deep(.vue3-easy-data-table__body tr td:first-child) {
    background-color: #d2e1e5;
}

:deep(.pagination__items-index) {
    display: none !important;
}

:deep(.el-input__prefix) {
    width: 0 !important;
}

:deep(.el-input__wrapper) {
    border-radius: 0 !important;
    height: 37px;
}

:deep(.vue3-easy-data-table__main) {
    background-color: #ededed;
}

:deep(.next-page__click-button .arrow) {
    margin-top: 21px;
    margin-left: 40px;
}

:deep(.vue3-easy-data-table__footer) {
    display: none !important;
}

.searcher {
    height: 40px;
    width: 295px;
    font-weight: 600;
}

:deep(.el-input__wrapper.is-focus) {
    border: 2px solid #41abc4 !important;
}

:deep(.pagination__rows-per-page) {
    display: none !important;
}

:deep(.vue3-easy-data-table__footer) {
    justify-content: center !important;
}

:deep(.vue3-easy-data-table__body tr:hover td:first-child) {
    background-color: #d2e1e5 !important;
}

:deep(.vue3-easy-data-table__body tr td:first-child) {
    text-align: center !important;
    background-color: #d2e1e5 !important;
}

:deep(.sortType-icon) {
    display: none !important;
}

.languages-table {
    --easy-table-header-font-size: 14px;
    --easy-table-body-row-font-size: 14px;
    --easy-table-border: none;

    --easy-table-body-row-hover-background-color: #fff;
}

.search-icon {
    width: 16px;
    height: 16px;
    opacity: 0.6;
}

.table-controls-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    margin-bottom: 20px;
}

.edit-button-vue {
    width: 24px !important;
    height: 24px !important;
}
</style>